#import "./chat-actions-fragment.graphql"

fragment ChatSettingsEngagementBarFragment on ChatSettings {
    lookAndFeel {
        color
        secondaryColor
        nameDisplay
        nudgeSettings {
            isEnabled
            message
            deviceVisibility
        }
        icon {
            type
            url
        }
        conversationStarter
        showPoweredBy
        disclaimerSettings {
            isEnabled
            message
        }
    }
    intakeForm {
        fields
        type
        allowThreadsWithoutContact
    }
    actions {
        ...ChatActionsFragment
    }
}
